import { LargeStrandTile } from "@components/strands/LargeStrandTile"
import { TabControl } from "@components/ui/TabControl"
import { ResultBrowser } from "@components/util/ResultBrowser"
import { ContentBlocks } from "eddev/blocks"
import { useSearchParams } from "eddev/routing"
import { defineView } from "eddev/views"
import { AnimatePresence, motion } from "motion/react"
import { useMemo } from "react"

export const meta: ViewMeta = {
  templateName: "Strand Index",
}

export default defineView("archive-strand", (props) => {
  // Query parameters
  const [_, filters] = useSearchParams({
    category: "all",
  })

  // // Build a list of all the cards, so they don't have to be re-rendered on each scroll event
  const cards = useMemo(() => {
    let results = props.strands?.nodes ?? []

    if (filters.get("category") !== "all") {
      results = results.filter((strand) => strand?.info?.category?.slug === filters.get("category"))
    }

    return results.map((post, i) => (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.4 } }}
        transition={{
          when: "beforeChildren",
          duration: 0.3,
        }}
        key={post.uri}
        layoutId={post.uri!}
        layout="position"
        className="overflow-hidden isolate will-change-transform"
      >
        <LargeStrandTile strand={post!} direction={i % 2 ? "left" : "right"} />
        <div className="h-5" />
      </motion.div>
    ))
  }, [props.strands?.nodes, filters.get("category")])

  return (
    <div>
      {/* Page header */}
      <ContentBlocks blocks={props.page?.contentBlocks} />

      {/* Results */}
      <ResultBrowser
        totalItems={cards.length}
        itemsPerPage={0}
        loading={false}
        animationKey={""}
        scrollKey={filters.get("category")}
        tabs={{
          value: filters.get("category"),
          onValueChange: filters.setter("category") as any,
          items: [
            { label: "All", value: "all" },
            ...(props.strandCategories?.nodes?.map((category) => ({
              label: category.name!,
              value: category.slug!,
            })) ?? []),
          ],
        }}
      >
        <motion.div className="w-grid mx-auto" layoutRoot>
          <AnimatePresence mode="popLayout" initial={false} presenceAffectsLayout>
            {cards}
          </AnimatePresence>
        </motion.div>
      </ResultBrowser>
      <div className="h-10" />
    </div>
  )
})
